//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'

export default {
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      serviceObjects: [],
      loading: false,
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'number',
          label: 'Номер объекта',
          align: 'left',
          field: 'number',
          sortable: true
        },
        {
          name: 'fvfComplexNumber',
          label: 'Номер комплекса',
          align: 'left',
          field: 'fvfComplexNumber',
          sortable: true
        },
        {
          name: 'typeAlias',
          label: 'Тип',
          align: 'left',
          field: 'typeAlias',
          sortable: true
        },
        {
          name: 'address',
          label: 'Адрес',
          align: 'left',
          field: 'address',
          sortable: true
        }
      ]
    }
  },
  created: function () {
    if (this.request.requestsToAudit) {
      this.loadServiceObjectsByRequestId()
    } else if (this.request.objectsToAudit) {
      this.loadServiceObjectsById()
    }
  },
  methods: {
    loadServiceObjectsByRequestId: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/request/getRequestsObjects?requestIds=' + this.request.requestsToAudit,
        onSuccess: (response) => {
          this.serviceObjects = response.data.result
        },
        onFailure: 'Ошибка загрузки списка объектов обслуживания',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    loadServiceObjectsById: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/serviceobject/search?filter=none&ids=' + this.request.objectsToAudit,
        onSuccess: (response) => {
          this.serviceObjects = response.data.result
        },
        onFailure: 'Ошибка загрузки списка объектов обслуживания',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

